import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import tw from 'tailwind.macro';
const Input = styled('input')`
  ${tw`border-accent bg-white px-3 py-4 w-full block tracking-wide`}
  border-width: 1px;
`;
export default Input;



// WEBPACK FOOTER //
// ./src/components/Form/Input.js